import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.loadScripts();
    }
  }

  loadScripts() {
    const scripts = [
      'assets/js/vendor/jquery.min.js',
      'assets/js/vendor/jquery-ui.js',
      'assets/js/vendor/metismenu.js',
      'assets/js/vendor/magnifying-popup.js',
      'assets/js/plugins/swiper.js',
      'assets/js/plugins/counterup.js',
      'assets/js/vendor/waypoint.js',
      'assets/js/vendor/waw.js',
      'assets/js/plugins/isotop.js',
      'assets/js/plugins/imagesloaded.pkgd.min.js',
      'assets/js/plugins/resizer-sensor.js',
      'assets/js/plugins/sticky-sidebar.js',
      'assets/js/plugins/twinmax.js',
      'assets/js/vendor/chroma.min.js',
      'assets/js/plugins/bootstrap.min.js',
      'assets/js/plugins/contact.form.js',
      'assets/js/plugins/calender.js',
      'assets/js/main.js'
    ];

    for (const script of scripts) {
      const scriptElement = document.createElement('script');
      scriptElement.src = script;
      scriptElement.async = false;
      document.body.appendChild(scriptElement);
    }
  }
}
